export const cvInfo = {
    avatar: "../empty.jpg",
    personalDetails: {
        name: 'Your Name',
        subtitle: 'Web Developer',
        email: 'abtahitajwar@gmail.com',
        phone: '+88 01796 391053',
        address: 'Jowar Sahara, Pragati Sharani',
        website: 'https://abtahi-tajwar.github.io/abtahitajwar',
        about: `I’m a master coach, best-selling author and a passionate speaker. I’m the founder of the first women-only hedge fund, special counsellor in many corporations across the globe. I’ve found balance between work and life, now I’m a totally happy person, loving mother, inspiring speaker and writer, and firm investor, but it didn’t come easily. I've gone though hundreds of failures and complicated situations. You can use my previous experience in order not to fall into the same trap. `,

        linkedin: 'https://www.linkedin.com/in/abtahi-tajwar/',
        github: 'https://www.github.com/',
        facebook: '',
        instagram: '',
        twitter: '',
        pinterest: '',
        skype: ''
    },
    skills: [
        {
            skill: "Problem Solving",
            rating: 75
        },
        {
            skill: "Web Design",
            rating: 48
        },
        {
            skill: "Programming",
            rating: 94
        }
    ],
    language: [
        {
            language: "English",
            rating: 4
        },
        {
            language: "Bangla",
            rating: 1
        }
    ],
    employment: [
        {
            title: "Content Marketing Lead",
            subtitle: "Pipedrive, London",
            date: "11 JAN - Present",
            description: "Madison Blackstone is a director of brand marketing, with experience managing global teams and multi-million-dollar campaigns. Her background in brand strategy, visual design, and account management inform her mindful but competitive approach."
        },
        {
            title: "Web Developer",
            subtitle: "Chittagong, Bangladesh",
            date: "14 MAR - 13 DEC",
            description: "Madison Blackstone is a director of brand marketing, with experience managing global teams and multi-million-dollar campaigns. Her background in brand strategy, visual design, and account management inform her mindful but competitive approach."
        },
        {
            title: "Junior Web Developer",
            subtitle: "Pipedrive, London",
            date: "1 FEB - 22 MAR",
            description: "Madison Blackstone is a director of brand marketing, with experience managing global teams and multi-million-dollar campaigns. Her background in brand strategy, visual design, and account management inform her mindful but competitive approach."
        }
    ],
    education: [
        {
            title: "American International University",
            subtitle: "B.Sc.",
            date: "20 Mar - Present",
            description: "Madison Blackstone is a director of brand marketing, with experience managing global teams and multi-million-dollar campaigns. Her background in brand strategy, visual design, and account management inform her mindful but competitive approach."
        }
    ],
    projects: [
        {
            title: "Online CV MAker",
            subtitle: "https://github.com/abtahi-tajwar/ResumeBuilder",
            date: "20 MAR - 29 MAR",
            description: "Madison Blackstone is a director of brand marketing, with experience managing global teams and multi-million-dollar campaigns. Her background in brand strategy, visual design, and account management inform her mindful but competitive approach."
        }
    ],
    certificates: [
        {
            title: "Expert Reactjs Developer Full Course",
            subtitle: "React js, Javascript",
            date: "20 Mar - Present",
            description: "Madison Blackstone is a director of brand marketing, with experience managing global teams and multi-million-dollar campaigns. Her background in brand strategy, visual design, and account management inform her mindful but competitive approach."
        }
    ],
    references: [
        {
            name: "Mr. Michel Robinson",
            subtitle: "Graphics Designer",
            phone: "+880 1796-391053",
            email: "michelrobinshon@gmail.com"
        },
        {
            name: "Begum Rokeya",
            subtitle: "Graphics Designer",
            phone: "+880 1796-391053",
            email: "begumrokeya@gmail.com"
        }
    ]
}